import { Field, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '@ibe/ui';
import { Controller, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form';

import { IconUpload } from '../../../components/media/icon-upload.js';
import {
  AMENITY_CATEGORY_OPTIONS,
  AMENITY_TYPE_OPTIONS,
  type AmenityFormInput,
} from '../api/schemas.js';

export function AmenityFields({
  register,
  errors,
  control,
  lockedType,
}: {
  readonly register: UseFormRegister<AmenityFormInput>;
  readonly errors: FieldErrors<AmenityFormInput>;
  readonly control: Control<AmenityFormInput>;
  readonly lockedType?: 'PROPERTY' | 'ROOM';
}): React.JSX.Element {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field error={errors.code?.message} required>
          <FieldLabel>Code</FieldLabel>
          <FieldInput autoComplete="off" placeholder="WIFI" {...register('code')} />
        </Field>
        <Field error={errors.name?.message} required>
          <FieldLabel>Name</FieldLabel>
          <FieldInput autoComplete="off" placeholder="Wi-Fi" {...register('name')} />
        </Field>
      </div>
      <Field error={errors.type?.message} required>
        <FieldLabel>Type</FieldLabel>
        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <FieldSelect
              value={field.value}
              options={AMENITY_TYPE_OPTIONS}
              placeholder="Select a type"
              onValueChange={field.onChange}
              onBlur={field.onBlur}
              disabled={lockedType !== undefined}
              searchable
            />
          )}
        />
      </Field>
      <Field error={errors.category?.message} required>
        <FieldLabel>Category</FieldLabel>
        <Controller
          control={control}
          name="category"
          render={({ field }) => (
            <FieldSelect
              value={field.value}
              options={AMENITY_CATEGORY_OPTIONS}
              placeholder="Select a category"
              onValueChange={field.onChange}
              onBlur={field.onBlur}
              searchable
            />
          )}
        />
      </Field>
      <Field
        error={errors.iconUrl?.message}
        description="Upload an SVG icon, or leave it blank. Inline SVG markup is not accepted."
      >
        <FieldLabel>Icon</FieldLabel>
        <Controller
          control={control}
          name="iconUrl"
          render={({ field }) => (
            <IconUpload
              value={field.value}
              onChange={field.onChange}
              disabled={field.disabled}
              error={errors.iconUrl?.message}
            />
          )}
        />
      </Field>
      <Field error={errors.description?.message}>
        <FieldLabel>Description</FieldLabel>
        <FieldTextarea {...register('description')} />
      </Field>
    </div>
  );
}
